import { Component, type ComponentInterface, Prop, State, h } from '@stencil/core';
import { MainMenu } from '~/components/wpm-header/MainMenu';
import { trackMenuClick } from '~/util/analytics';

/**
 * @internal
 */
@Component({
  tag: 'ltc-wpm-header-mobile',
  styleUrl: 'wpm-header-mobile.less',
  shadow: true,
})
export class WpmHeaderMobile implements ComponentInterface {
  /*
   * 1. Own Properties
   */

  /*
   * 2. Reference to host HTML element.
   */

  /*
   * 3. State() variables
   */
  @State() activeSection: string | null = null;

  /*
   * 4. Public Property API
   */
  @Prop() authenticated = false;

  /*
   * Prop lifecycle events
   */

  /*
   * 5. Events section
   */

  /*
   * 6. Component lifecycle events
   */

  /*
   * 7. Listeners
   */

  /*
   * 8. Public methods API
   */

  /*
   * 9. Local methods
   */
  toggleSection = (section: string) => {
    this.activeSection = this.activeSection === section ? null : section;
  };

  renderSectionChevron = (sectionName: string) => {
    return this.activeSection === sectionName ? (
      <ltc-icon name="chevron-up" size="small" color="#ffffff" aria-label="Collapse" />
    ) : (
      <ltc-icon name="chevron-down" size="small" color="#ffffff" aria-label="Expand" />
    );
  };

  /*
   * 10. render() function
   */
  render() {
    return (
      <nav class="main-nav" aria-label="Main Site Navigation">
        <ul class="nav-list">
          {MainMenu.map((m) => {
            return (
              <li class="nav-item" data-section={m.id} key={m.id}>
                <button
                  type="button"
                  class={{ 'nav-link': true, open: this.activeSection === m.id }}
                  aria-label={`${m.name}, ${this.activeSection === m.id ? 'hide' : 'see more'}`}
                  aria-expanded={this.activeSection === m.id ? 'true' : 'false'}
                  onClick={() => this.toggleSection(m.id)}
                >
                  <span>
                    <ltc-icon name={m.id} size="small" color="#ffffff" aria-label={m.name} />
                    {m.name}
                  </span>
                  {this.renderSectionChevron(m.id)}
                </button>
                <ul
                  class={{ submenu: true, open: this.activeSection === m.id }}
                  aria-hidden={this.activeSection === m.id ? 'false' : 'true'}
                >
                  {m.subMenu.map((sub) => {
                    return (
                      <li key={sub.urlPath}>
                        <a href={REPLACE_LT_WWW_URL + sub.urlPath} onClick={() => trackMenuClick(sub.name)}>
                          {sub.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          })}
        </ul>
        {this.authenticated ? null : (
          <ul class="more-nav">
            <li class="slogan">Get your free credit score in minutes!</li>
            <li>
              <div class="menu-sign-in-btn-block">
                <a href={`${REPLACE_MY_LT_URL}/homebase?icid=header+signin`} rel="nofollow" onClick={() => trackMenuClick('Login')}>
                  Login
                </a>
                <a href={`${REPLACE_MY_LT_URL}/enroll?icid=header-signup`} onClick={() => trackMenuClick('Sign Up for Free')}>
                  Sign Up for Free
                </a>
              </div>
            </li>
          </ul>
        )}
      </nav>
    );
  }
}
